var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9572 3.17633C13.7229 2.94202 13.343 2.94202 13.1087 3.17633L4.34056 11.9444C4.27115 12.0138 4.21983 12.0992 4.1911 12.1931L3.03667 15.9642C2.84899 16.5773 3.42271 17.151 4.0358 16.9633L7.80694 15.8089C7.9008 15.7802 7.98617 15.7289 8.05558 15.6594L16.8237 6.89135C17.058 6.65704 17.058 6.27714 16.8237 6.04282L13.9572 3.17633ZM11.9829 5.99919L13.5329 4.44912L15.5509 6.46709L14.0008 8.01715L11.9829 5.99919ZM11.1229 6.85914L5.29479 12.6873L4.40451 15.5955L7.31275 14.7052L13.1409 8.8771L11.1229 6.85914Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic_edit.d33ff7df2228dcd6fcb4236047f99a6f.svg";
export { ForwardRef as ReactComponent };